import React from 'react';
import { I18n } from '@aws-amplify/core';
import { FormItemWrapper } from './FormItemWrapper';

import InputNumber from '@/components/ui/InputNumber';

interface WorkdayDurationFormItemProps {
	fieldName?: string | string[];
	required?: boolean;
}

export function WorkdayDurationFormItem({ required = true, fieldName }: Readonly<WorkdayDurationFormItemProps>): JSX.Element {
	return (
		<FormItemWrapper
			label={<span style={{ whiteSpace: 'nowrap' }}>{I18n.get('Duration of the workday')}</span>}
			name={fieldName}
			required={required}
			requiredMessage={I18n.get('The field requires an answer')}
		>
			<InputNumber placeholder={I18n.get('Duration of the workday')} />
		</FormItemWrapper>
	);
}
